import type { PropsWithChildren, ReactNode } from "react";

import * as Tooltip from "@radix-ui/react-tooltip";

type HoverTooltipProps = PropsWithChildren<{
  readonly content: string;
}>;

export function HoverTooltip({
  children,
  content,
}: HoverTooltipProps): ReactNode {
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Content className="animate-slideUpAndFade bg-gray-darker rounded-md px-3 py-1 text-sm text-white will-change-[transform,opacity]">
          <div>{content}</div>
          <Tooltip.Arrow className="fill-gray-darker" />
        </Tooltip.Content>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
